import { useState } from "react";
import api from "../services/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const res = await api.post("/api/auth/forgot-password", { email });
      setMessage(res.data.message || "If an account exists, a reset link has been sent.");
    } catch (err: any) {
      setMessage("Failed to send reset link. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-shell flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-extrabold text-secondary mb-2">Reset your password</h1>
          <p className="text-textMuted">Enter your email and we'll send you a reset link</p>
        </div>

        <div className="ui-card p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <input
              type="email"
              placeholder="Your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="ui-input"
            />

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full py-4 text-lg"
            >
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>

          {message && (
            <p className="mt-6 text-center text-sm font-medium text-success">{message}</p>
          )}

          <p className="mt-8 text-center text-textMuted">
            Remember your password?{" "}
            <a href="/login" className="font-semibold text-primary hover:underline">
              Back to login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}